module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/write-a-wedding-guest-book-entry-719b794436c07f9e9379248e53ea2861.jpg";